import { GameUIMessageType, StopAutoplayClickedMessage } from 'game-ui-types'
import { useUltraPlayStore } from '@stores/ultraPlayStore'
import { collectUltraPlayWin } from './ultraPlayCollect'
import { ultraPlayAnalytics } from './ultraPlayAnalytics'

export const isUltraPlayPauseBlocked = (): boolean => {
    const up = useUltraPlayStore.getState()

    return up.isBetInFlight || up.hasUnrecordedBet || up.isInFeature || up.isBuyBonusRoundInFlight
}

let pendingBetChange: ((betIndex: number) => void) | null = null

export const deferUltraPlayBetChange = (send: (betIndex: number) => void) => {
    pendingBetChange = send
}

export const clearPendingUltraPlayBetChange = () => {
    pendingBetChange = null
}

const flushPendingUltraPlayBetChange = () => {
    if (!pendingBetChange) return

    const send = pendingBetChange

    pendingBetChange = null
    send(useUltraPlayStore.getState().selectedBetIndex)
}

export const executeUltraPlayPause = () => {
    const up = useUltraPlayStore.getState()

    // Tracked here rather than at the button: a blocked pause is deferred and flushed later, and this
    // is the one place both routes converge on — so a pause reports exactly once, when it takes effect.
    ultraPlayAnalytics.sessionPaused()
    up.pause()
    up.setAwaitingAutoplayStop(true)
    collectUltraPlayWin()
    window.postMessage({ type: GameUIMessageType.STOP_AUTOPLAY_CLICKED } as StopAutoplayClickedMessage, '*')
    flushPendingUltraPlayBetChange()
}

export const requestUltraPlayAutoplayStop = () => {
    const up = useUltraPlayStore.getState()

    up.setPausePending(true)
    up.setAwaitingAutoplayStop(true)
    window.postMessage({ type: GameUIMessageType.STOP_AUTOPLAY_CLICKED } as StopAutoplayClickedMessage, '*')
}

export const confirmUltraPlayAutoplayStop = () => {
    const up = useUltraPlayStore.getState()

    if (up.isAwaitingAutoplayStop) up.setAwaitingAutoplayStop(false)
}

export const flushPendingUltraPlayPause = () => {
    const up = useUltraPlayStore.getState()

    if (!up.isPausePending) return

    if (up.status !== 'PLAYING') {
        up.setPausePending(false)
        clearPendingUltraPlayBetChange()

        return
    }

    if (up.isAwaitingAutoplayStop) return

    if (isUltraPlayPauseBlocked()) return

    executeUltraPlayPause()
}
